import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrl } from '../Utils/api';

// Async thunk for fetching policy stats
export const fetchPolicyStats = createAsyncThunk(
  'policy/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('auth-token');
      const response = await axios.get(`${baseUrl}/policy/stats`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch policy stats');
    }
  }
);

const initialState = {
  stats: {
    data: null,
    loading: false,
    error: null
  }
};

const policySlice = createSlice({
  name: 'policy',
  initialState,
  reducers: {
    clearPolicyStats: (state) => {
      state.stats.data = null;
      state.stats.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchPolicyStats
      .addCase(fetchPolicyStats.pending, (state) => {
        state.stats.loading = true;
        state.stats.error = null;
      })
      .addCase(fetchPolicyStats.fulfilled, (state, action) => {
        state.stats.loading = false;
        state.stats.data = action.payload;
      })
      .addCase(fetchPolicyStats.rejected, (state, action) => {
        state.stats.loading = false;
        state.stats.error = action.payload;
      });
  }
});

export const { clearPolicyStats } = policySlice.actions;
export default policySlice.reducer; 